import * as React from "react";
import type { SVGProps } from "react";
const SvgProductSelectedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M8.324 16.394a7.903 7.903 0 1 0 0-15.806 7.903 7.903 0 0 0 0 15.806"
    />
    <path
      fill="#18A09F"
      d="M7.179 11.916h-.005a.8.8 0 0 1-.594-.275L4.213 8.892a.79.79 0 1 1 1.198-1.031l1.776 2.062 4.058-4.59a.79.79 0 0 1 1.184 1.047L7.771 11.65a.8.8 0 0 1-.592.267"
    />
  </svg>
);
export default SvgProductSelectedIcon;
